import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { format } from 'date-fns';
import React from 'react';
import { getStatusInfo } from '../utils/certificateStatusUtils';

const PLTPCertificateVerification = ({ certificate }) => {
   const isExpired = certificate.expiryDate ? new Date(parseInt(certificate.expiryDate)) < new Date() : false;
   const statusInfo = getStatusInfo(certificate.certificateStatus, isExpired);

   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
   };

   // Handle cases where pltpCertificateData might be undefined
   const certificateData = certificate.pltpCertificateData || {};

   return (
      <div className="space-y-6">
         <div className="text-center mb-8">
            <statusInfo.icon className="mx-auto h-12 w-12 text-gray-600" />
            <h2 className="mt-4 text-3xl font-bold text-gray-900">
               Private Land Timber Permit Verification
            </h2>
         </div>

         <Card className="p-6 mb-6">
            <div className="flex justify-between items-center mb-6">
               <h3 className="text-lg font-semibold">Certificate Status</h3>
               <Badge className={statusInfo.color}>
                  {statusInfo.label}
               </Badge>
            </div>

            <div className="space-y-4">
               <div>
                  <h4 className="text-sm font-medium text-gray-500">Certificate Number</h4>
                  <p className="text-lg">{certificate.certificateNumber}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Owner Information</h4>
                  <p className="text-lg">{certificateData.name}</p>
                  <p className="text-gray-600">{certificateData.address}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Property Details</h4>
                  <p><span className="font-medium">Lot Number:</span> {certificateData.lotNumber}</p>
                  <p><span className="font-medium">OCT Number:</span> {certificateData.octNumber}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Timber Information</h4>
                  <p><span className="font-medium">Total Trees:</span> {certificateData.totalTrees}</p>
                  <p><span className="font-medium">Gross Volume:</span> {certificateData.totalGrossVolume}</p>
                  <p><span className="font-medium">Net Volume:</span> {certificateData.totalNetVolume}</p>
               </div>

               <div>
                  <h4 className="text-sm font-medium text-gray-500">Validity Period</h4>
                  <p><span className="font-medium">Issue Date:</span> {formatDate(certificate.dateIssued)}</p>
                  <p><span className="font-medium">Expiry Date:</span> {formatDate(certificate.expiryDate)}</p>
               </div>
            </div>
         </Card>
      </div>
   );
};

export default PLTPCertificateVerification;
